import { Component, EventEmitter, Input, SimpleChanges, OnChanges, Output } from '@angular/core';
import { Visualize3dObject, findInTree, getParent } from 'projects/visualize3d/src/public-api';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { NestedTreeControl } from '@angular/cdk/tree';

@Component({
  selector: 'app-object3d-tree',
  templateUrl: './object3d-tree.component.html',
  styleUrls: ['./object3d-tree.component.css'],
  standalone: false,
})
export class Object3dTreeComponent implements OnChanges {
  @Input() v3dObject: Visualize3dObject;

  private selectedV3dObjectValue: Visualize3dObject;

  @Input() get selectedV3dObject(): Visualize3dObject {
    return this.selectedV3dObjectValue;
  }

  set selectedV3dObject(v3dObject: Visualize3dObject) {
    this.selectedV3dObjectValue = v3dObject;
    this.selectedV3dObjectChange.emit(this.selectedV3dObjectValue);
    if (this.selectedV3dObjectValue) {
      this.expandParents(this.selectedV3dObjectValue);
    }
  }

  @Output() selectedV3dObjectChange = new EventEmitter<Visualize3dObject>();

  treeControl = new NestedTreeControl<Visualize3dObject>(node => node.children);
  dataSource = new MatTreeNestedDataSource<Visualize3dObject>();

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.v3dObject) {
      if (!changes.v3dObject.currentValue) {
        this.dataSource.data = [];
        return;
      }

      // TreeControl tracks the expanded/collapsed state by object reference -
      // we need  to persist the expanded/collapsed state manually by node id due to data immutability
      const expandedNodeIds = this.treeControl.expansionModel.selected.filter(n => !!n).map(n => n.id);

      const treeData = [];
      treeData.push(changes.v3dObject.currentValue);
      this.dataSource.data = treeData;

      this.treeControl.collapseAll();
      for (const nodeId of expandedNodeIds) {
        const object3d = findInTree(changes.v3dObject.currentValue, n => n.id === nodeId);
        this.treeControl.expand(object3d);
      }
    }
  }

  treeNodeClicked(node: Visualize3dObject): void {
    if (this.selectedV3dObject === node) {
      this.selectedV3dObject = null;
      return;
    }
    this.selectedV3dObject = node;
  }

  isSelected(v3dObject: Visualize3dObject): boolean {
    if (!this.selectedV3dObject) {
      return false;
    }
    return v3dObject === this.selectedV3dObject;
  }

  hasChild = (index: number, node: Visualize3dObject): boolean => !!node.children && node.children.length > 0;

  expandParents(node: Visualize3dObject): void {
    node = getParent(this.v3dObject, node);
    while (node) {
      this.treeControl.expand(node);
      node = getParent(this.v3dObject, node);
    }
  }
}
